import { Record } from 'immutable';

export const Register = new Record({
    id: null,
    isPending: false,
    isNew: true,
    error: 0,
    data: {}
});